import { Component, h, Prop, Element } from '@stencil/core';

/**
 * @slot default - Label text content
 */
@Component({
  tag: 'me-label',
  styleUrl: 'index.scss',
  shadow: false,
})
export class Label {
  @Element() element: HTMLElement;

  /**
   * Color variant of the label
   * @type {'primary' | 'secondary' | 'success' | 'error'}
   * @default 'primary'
   */
  @Prop() color?: 'primary' | 'secondary' | 'success' | 'error' = 'primary';

  render() {
    return (
      <div
        class={{
          label: true,
          [`label--${this.color}`]: true,
        }}
      >
        <slot></slot>
      </div>
    );
  }
}
